<template>
  <div>
    <ul>
      <li
        class="li-item"
        v-for="(item,index) in arrList"
        :key="index"
      >

        <el-row
          :gutter="20"
          type="flex"
          align="middle"
          justify="center"
        >
          <el-col :span="2">{{index+1}}</el-col>
          <el-col :span="4"><img
              :src="item.poster"
              alt=""
            ></el-col>
          <el-col :span="12" class="_name">{{item.name}}</el-col>
          <el-col :span="8" class="_name">转发数:{{item.numberOfReleases}}</el-col>
        </el-row>
      </li>

    </ul>
  </div>
</template>
<script>
export default {
  props: ["wmList"],
  data() {
    return {
      arrList: []
    };
  },
  watch:{
    wmList(newval){
      if(newval){
        this.arrList=newval
      }
    }
  }
};
</script>
<style lang="scss" scoped>
// .li-item{
//   display: flex;
//   .sp1{
//     width: 5rem;

//   }
//   .net-img{
//       display: flex;
//       align-items: center;
//     }
// }
.li-item{
  margin-bottom: 4rem;
}
img{
  width: 10rem;
  height: 10rem;
}
._name{
  overflow:hidden;

  white-space: nowrap;

  text-overflow: ellipsis;
}

</style>